import React from 'react';
import { FileTree } from './FileTree';
import { LivePreview } from './LivePreview';
import { FileItem } from '../types/space';
import { ChevronRight } from 'lucide-react';
interface ContextSidebarProps {
  files: FileItem[];
  isOpen: boolean;
  onToggle: () => void;
}
export function ContextSidebar({
  files,
  isOpen,
  onToggle
}: ContextSidebarProps) {
  if (!isOpen) {
    return <div className="w-0 overflow-hidden transition-all duration-300 ease-in-out border-l border-gray-200 bg-white relative" data-id="element-49">
        <button onClick={onToggle} className="absolute top-4 -left-8 bg-white border border-gray-200 rounded-l-md p-1 shadow-sm z-30" data-id="element-50">
          <ChevronRight className="h-4 w-4 text-gray-500 rotate-180" data-id="element-51" />
        </button>
      </div>;
  }
  return <div className="w-[380px] flex-shrink-0 flex flex-col border-l border-gray-200 bg-white h-full transition-all duration-300 ease-in-out" data-id="element-52">
      {/* Top: Live Preview */}
      <div className="flex-1 min-h-0 flex flex-col" data-id="element-53">
        <LivePreview data-id="element-54" />
      </div>

      {/* Bottom: File Tree */}
      <div className="h-[280px] flex-shrink-0 border-t border-gray-200 flex flex-col bg-white" data-id="element-55">
        <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between" data-id="element-56">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-57">
            Project Files
          </span>
          <span className="text-xs text-gray-400" data-id="element-58">4 files</span>
        </div>
        <div className="flex-1 overflow-y-auto py-2" data-id="element-59">
          <FileTree files={files} data-id="element-60" />
        </div>
      </div>
    </div>;
}